import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';

class EditPermissionModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      name : '',
      description : ''
    }

    this.handleCancel = this.handleCancel.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  handleCancel() {
    this.setState({name : '', description : ''})
    this.props.onHide()
  }

  handleSubmit() {
    this.props.handleSubmit(this.state.name, this.state.description)
    this.setState({name : '', description : ''})
    this.props.onHide()
  }

  handleKeyDown(e) {
    if(e.key == 'Enter') {
      this.handleSubmit()
    }
  }

  componentDidUpdate(prev_props) {
    if(prev_props.show === false && this.props.show === true) {
      this.setState({name : this.props.current_name, description : this.props.current_description})
    }
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        >
        <div className='edit-permission-modal-container'>
          <div className='panel panel-primary'>
            <div className='panel-heading thin-modal-heading'>
              <h4>Edit Permission</h4>
            </div>
            <Modal.Body>
              <div className='row'>
                <div className='col-md-12 col-xs-12'>
                  <label>Name</label>
                  <input
                    value={this.state.name}
                    onChange={(e) => {this.setState({name : e.target.value})}}
                    className='form-control'
                    autoFocus
                    onKeyDown={(e) => {this.handleKeyDown(e)}}
                  />
                </div>
                <div className='col-md-12 col-xs-12'>
                  <label>Description</label>
                  <input
                    value={this.state.description}
                    onChange={(e) => {this.setState({description : e.target.value})}}
                    className='form-control'
                    autoFocus
                    onKeyDown={(e) => {this.handleKeyDown(e)}}
                  />
                </div>
              </div>
              <div className='row mt-md'>
                <div className='col-md-6 col-xs-6'>
                  <div
                    className='btn btn-block btn-default'
                    onClick={this.handleCancel}
                    >
                    Cancel
                  </div>
                </div>
                <div className='col-md-6 col-xs-6'>
                  <div
                    className='btn btn-block btn-primary'
                    onClick={this.handleSubmit}
                    >
                    Submit
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </div>
      </Modal>
    )
  }
}

export default EditPermissionModal



// WEBPACK FOOTER //
// ./src/browser/components/permissions/edit-permission-modal.js